import {
  MdTouchApp,
  MdPlayArrow,
  MdHeadset,
  MdAvTimer,
  MdSkipNext,
  MdFavorite,
  MdFavoriteBorder,
  MdPerson,
  MdPersonOutline,
  MdPeopleOutline,
  MdTerrain,
  MdReplay
} from "react-icons/md";
import { humanize, formatDuration } from "../../utils/formatDigits";

export default {
  single: {
    clickCount: {
      label: 'تعداد کلیک‌ها',
      bgClass: 'bg-success text-light',
      formatter: humanize,
      icon: MdTouchApp,
    },
    playCount: {
      label: 'تعداد پخش‌ها',
      bgClass: 'bg-white text-dark',
      formatter: humanize,
      icon: MdPlayArrow,
      style: {
        boxShadow: 'inset 0 0 0px 1px'
      }
    },
    listenSum: {
      label: 'تعداد شنیدن',
      bgClass: 'bg-info text-light',
      formatter: humanize,
      icon: MdHeadset,
    },
    durationSum: {
      label: 'زمان شنیدن',
      bgClass: 'bg-dark text-light',
      formatter: formatDuration,
      icon: MdAvTimer
    },
    skipSum: {
      label: 'جمع ردشدن‌ها',
      bgClass: 'bg-warning text-danger',
      formatter: humanize,
      icon: MdSkipNext
    },
    likeCount: {
      label: 'تعداد لایک‌ها',
      bgClass: 'bg-danger text-light',
      formatter: humanize,
      icon: MdFavorite
    },
    unlikeCount: {
      label: 'تعداد آنلایک‌ها',
      bgClass: 'bg-white text-danger',
      formatter: humanize,
      icon: MdFavoriteBorder,
      style: {
        boxShadow: 'inset 0 0 0px 1px'
      }
    },
    returnAverage: {
      label: 'میانگین بازگشت',
      bgClass: 'bg-primary text-light',
      formatter: humanize,
      icon: MdReplay
    },
    returnSTD: {
      label: 'انحراف از معیار بازگشت',
      bgClass: 'bg-secondary text-light',
      formatter: humanize,
      icon: MdTerrain
    }
  },
  charts: {
    dailyDurationAverage: {
      color: '#ffc107',
      formatter: formatDuration
    },
    dailyDurationCount: {
      color: '#007bff',
      formatter: humanize,
    },
    dailyDurationSTD: {
      color: '#17a2b8',
      formatter: formatDuration
    },
    dailyDurationSum: {
      color: '#dc3545',
      formatter: formatDuration
    },
    dailyListensToSkips: {
      color: '#343a40',
      formatter: humanize
    },
    dailyLikesToUnlikes: {
      color: '#28a745',
      formatter: humanize
    }
  },
  tables: {
    topTrackClicks: {
      label: 'آهنگ‌های بیشتر کلیک‌شده',
      formatter: humanize,
    },
    topTrackPlays: {
      label: 'آهنگ‌های بیشتر پخش‌شده',
      formatter: humanize,
    },
    topTrackListens: {
      label: 'آهنگ‌های بیشتر شنیده‌شده',
      formatter: humanize,
    },
    topTrackDurations: {
      label: 'آهنگ‌های با زمان بیشتر',
      formatter: formatDuration
    },
    topTrackSkips: {
      label: 'آهنگ‌های بیشتر رد شده',
      formatter: humanize,
    },
    topTrackLikes: {
      label: 'آهنگ‌های بیشتر لایک‌شده',
      formatter: humanize,
    },
    topTrackUnlikes: {
      label: 'آهنگ‌های بیشتر آنلایک‌شده',
      formatter: humanize,
    },
    topArtistClicks: {
      label: 'هنرمندان بیشتر کلیک‌شده',
      formatter: humanize,
    },
    topArtistPlays: {
      label: 'هنرمندان بیشتر پخش‌شده',
      formatter: humanize,
    },
    topArtistListens: {
      label: 'هنرمندان بیشتر شنیده‌شده',
      formatter: humanize,
    },
    topArtistDurations: {
      label: 'هنرمندان با زمان بیشتر',
      formatter: formatDuration
    },
    topArtistSkips: {
      label: 'هنرمندان بیشتر رد شده',
      formatter: humanize,
    },
    topArtistLikes: {
      label: 'هنرمندان بیشتر لایک‌شده',
      formatter: humanize,
    },
    topArtistUnlikes: {
      label: 'هنرمندان بیشتر آنلایک‌شده',
      formatter: humanize,
    },
    topAlbumClicks: {
      label: 'آلبوم‌های بیشتر کلیک‌شده',
      formatter: humanize,
    },
    topAlbumPlays: {
      label: 'آلبوم‌های بیشتر پخش‌شده',
      formatter: humanize,
    },
    topAlbumListens: {
      label: 'آلبوم‌های بیشتر شنیده‌شده',
      formatter: humanize,
    },
    topAlbumDurations: {
      label: 'آلبوم‌های با زمان بیشتر',
      formatter: formatDuration
    },
    topAlbumSkips: {
      label: 'آلبوم‌های بیشتر رد شده',
      formatter: humanize,
    },
    topAlbumLikes: {
      label: 'آلبوم‌های بیشتر لایک‌شده',
      formatter: humanize,
    },
    topAlbumUnlikes: {
      label: 'آلبوم‌های بیشتر آنلایک‌شده',
      formatter: humanize,
    },
    topTagClicks: {
      label: 'تگ‌های بیشتر کلیک‌شده',
      formatter: humanize,
    },
    topTagPlays: {
      label: 'تگ‌های بیشتر پخش‌شده',
      formatter: humanize,
    },
    topTagListens: {
      label: 'تگ‌های بیشتر شنیده‌شده',
      formatter: humanize,
    },
    topTagDurations: {
      label: 'تگ‌های با زمان بیشتر',
      formatter: formatDuration
    },
    topTagSkips: {
      label: 'تگ‌های بیشتر رد شده',
      formatter: humanize,
    },
    topTagLikes: {
      label: 'تگ‌های بیشتر لایک‌شده',
      formatter: humanize,
    },
    topTagUnlikes: {
      label: 'تگ‌های بیشتر آنلایک‌شده',
      formatter: humanize,
    },
    topChannelClicks: {
      label: 'کانال‌های بیشتر کلیک‌شده',
      formatter: humanize,
    },
    topChannelPlays: {
      label: 'کانال‌های بیشتر پخش‌شده',
      formatter: humanize,
    },
    topChannelListens: {
      label: 'کانال‌های بیشتر شنیده‌شده',
      formatter: humanize,
    },
    topChannelDurations: {
      label: 'کانال‌های با زمان بیشتر',
      formatter: formatDuration
    },
    topChannelSkips: {
      label: 'کانال‌های بیشتر رد شده',
      formatter: humanize,
    },
    topChannelLikes: {
      label: 'کانال‌های بیشتر لایک‌شده',
      formatter: humanize,
    },
    topChannelUnlikes: {
      label: 'کانال‌های بیشتر آنلایک‌شده',
      formatter: humanize,
    },
    topUserClicks: {
      label: 'کاربران بیشتر کلیک کرده',
      formatter: humanize,
    },
    topUserPlays: {
      label: 'کاربران بیشتر پخش کرده',
      formatter: humanize,
    },
    topUserListens: {
      label: 'کاربران بیشتر شنونده',
      formatter: humanize,
    },
    topUserDurations: {
      label: 'کاربران با زمان بیشتر',
      formatter: formatDuration
    },
    topUserSkips: {
      label: 'کاربران بیشتر رد کننده',
      formatter: humanize,
    },
    topUserLikes: {
      label: 'کاربران بیشتر لایک کننده',
      formatter: humanize,
    },
    topUserUnlikes: {
      label: 'کاربران بیشتر آنلایک کننده',
      formatter: humanize,
    }
  }
};

export const searchTypes = {
  artist: {
    label: 'هنرمند'
  },
  album: {
    label: 'آلبوم'
  },
  track: {
    label: 'آهنگ'
  },
  user: {
    label: 'کاربر'
  },
  channel: {
    label: 'کانال'
  },
  all: {
    label: 'همه'
  }
};
export const loginStates = {
  1: {
    icon: MdPerson,
    label: 'فقط لاگین‌شده‌ها'
  },
  2: {
    icon: MdPersonOutline,
    label: 'فقط لاگین‌نشده‌ها'
  },
  3: {
    icon: MdPeopleOutline,
    label: 'همه'
  }
};